import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { muiTextFieldSpaceStyle } from 'common/style/fields.style';

function NameDescription({ displayName, description, displayNameStyle, descStyle, isRequired }) {
    return (
        <div css={wrapperStyle}>
            <div css={[displayNameDefaultStyle, css(displayNameStyle)]}>
                {displayName}
                {isRequired && <span css={css(hintRequireStyle)}>*</span>}
            </div>
            {Boolean(description) && (
                <div css={[descDefaultStyle, css(descStyle)]}>{description}</div>
            )}
        </div>
    );
}

NameDescription.propTypes = {
    displayName: PropTypes.string,
    description: PropTypes.string,
    displayNameStyle: PropTypes.object,
    descStyle: PropTypes.object,
    isRequired: PropTypes.bool
};

export default NameDescription;

const hintRequireStyle = `
    color: #D52027;
`;

const displayNameDefaultStyle = css`
    font-size: 20px;
    ${muiTextFieldSpaceStyle}
`;

const descDefaultStyle = css`
    font-size: 14px;
    ${muiTextFieldSpaceStyle}
`;

const wrapperStyle = css`
    margin-bottom: 24px;
`;
